import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Header.css";
import logo from "../Assets/logo.png";

const Header = ({ setRole }) => {
  const [isDropdownVisible, setDropdownVisible] = useState(false);
  const [isDropdownVisiblen, setDropdownVisiblen] = useState(false);
  const [isLanguageDropdownVisible, setLanguageDropdownVisible] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userRole, setUserRole] = useState("guest");
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 800);
  const [menuOpen, setMenuOpen] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState("English");

  const navigate = useNavigate();
  const menuRef = useRef();
  const dropdownRef = useRef();
  const dropdownRefNews = useRef();
  const dropdownRefLanguage = useRef();

  const dropdown_toggle = () => {
    menuRef.current.classList.toggle("nav-menu-visible");
    setMenuOpen(!menuOpen);
  };

  useEffect(() => {
    const loggedInStatus = localStorage.getItem("isLoggedIn");
    const role = localStorage.getItem("role");
    if (loggedInStatus === "true") {
      setIsLoggedIn(true);
      setUserRole(role || "guest");
    }
  }, []);

  const closeDropdown = () => {
    setDropdownVisible(false);
    setDropdownVisiblen(false);
    setLanguageDropdownVisible(false);
    menuRef.current.classList.remove("nav-menu-visible");
    setMenuOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        (dropdownRef.current && !dropdownRef.current.contains(event.target)) &&
        (dropdownRefNews.current && !dropdownRefNews.current.contains(event.target)) &&
        (dropdownRefLanguage.current && !dropdownRefLanguage.current.contains(event.target))
      ) {
        setDropdownVisible(false);
        setDropdownVisiblen(false);
        setLanguageDropdownVisible(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("role");
    localStorage.removeItem("email");
    localStorage.setItem("isLoggedIn", "false");

    setRole(null);
    navigate("/");
  };

  const handleLanguageChange = (language) => {
    setSelectedLanguage(language);
    setLanguageDropdownVisible(false); 
    if (isMobile) {
      closeDropdown(); 
    }
  };

  useEffect(() => {
    const handleResize = () => {
        setIsMobile(window.innerWidth <= 800);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <header className="header">
      <div className="logo">
        <img src={logo} alt="logo" />
      </div>

      {/* NEW: Mobile Header Actions Container (Language + Hamburger) */}
      <div className="mobile-header-actions">
        
        {/* Language Dropdown for Mobile Header */}
        <li
          className="dropdown language-dropdown mobile-language-header"
          // CRITICAL FIX: Add onMouseEnter/Leave for better touch device compatibility,
          // but rely on onClick for the actual toggle functionality on touch.
          onMouseEnter={() => isMobile && setLanguageDropdownVisible(true)}
          onMouseLeave={() => isMobile && setLanguageDropdownVisible(false)}
          onClick={() => setLanguageDropdownVisible(!isLanguageDropdownVisible)} 
        >
          <span className="current-language">
            🌍 {selectedLanguage}
          </span>
          {/* Menu visibility controlled by isLanguageDropdownVisible state */}
          {isLanguageDropdownVisible && ( 
            <ul ref={dropdownRefLanguage} className="dropdown-menu mobile-dropdown-menu">
              <li>
                <button onClick={() => handleLanguageChange("English")}>
                  English
                </button>
              </li>
              <li>
                <button onClick={() => handleLanguageChange("Amharic")}>
                  አማርኛ (Amharic)
                </button>
              </li>
              <li>
                <button onClick={() => handleLanguageChange("Tigrigna")}>
                  ትግርኛ (Tigrigna)
                </button>
              </li>
              <li>
                <button onClick={() => handleLanguageChange("Afan Oromo")}>
                  Afaan Oromoo
                </button>
              </li>
            </ul>
          )}
        </li>
        

        {/* Hamburger / Close Icon */}
        <div className="nav_dropdown" onClick={dropdown_toggle}>
          {menuOpen ? "✖" : "☰"}
        </div>
      </div>

      <ul ref={menuRef} className="nav-links">
        <li>
          <Link to="/" onClick={closeDropdown}>
            Home
          </Link>
		  
        </li>

        {!isMobile && (
          <>
            {/* Services Dropdown (Desktop) */}
            <li
              className="dropdown"
              onMouseEnter={() => setDropdownVisible(true)}
              onMouseLeave={() => setDropdownVisible(false)}
            >
              <Link to="/services" onClick={closeDropdown}>
                Services
              </Link>
              {/* CRITICAL FIX: Ensuring the dropdown menu is wrapped in the visibility check */}
              {isDropdownVisible && ( 
                <ul ref={dropdownRef} className="dropdown-menu">
                  <li><Link to="/services/web-development" onClick={closeDropdown}>🌐 Web Development</Link></li>
                  <li><Link to="/services/app-development" onClick={closeDropdown}>📱 Mobile APP Development</Link></li>
                  <li><Link to="/services/dashboard" onClick={closeDropdown}>📊 Data Analysis Dashboard</Link></li>
                  <li><Link to="/services/tutorial" onClick={closeDropdown}>🎓 Tutorials</Link></li>
                  <li><Link to="/services/electrical" onClick={closeDropdown}>⚡ Electrical Consultancy</Link></li>
                </ul>
              )}
            </li>

            {/* News Dropdown (Desktop) */}
            <li
              className="dropdown"
              onMouseEnter={() => setDropdownVisiblen(true)}
              onMouseLeave={() => setDropdownVisiblen(false)}
            >
              <Link to="/news" onClick={closeDropdown}>
                News
              </Link>
              {isDropdownVisiblen && (
                <ul ref={dropdownRefNews} className="dropdown-menu">
                  <li><Link to="/news/technology" onClick={closeDropdown}>Technology</Link></li>
                  <li><Link to="/news/economics" onClick={closeDropdown}>Economics</Link></li>
                  <li><Link to="/news/sport" onClick={closeDropdown}>Sport</Link></li>
                  <li><Link to="/news/others" onClick={closeDropdown}>Others</Link></li>
                </ul>
              )}
            </li>
            
            <li>
              <Link to="/contact" onClick={closeDropdown}>
                Contact....
              </Link>
            </li>

            <li>
              <Link to="/download1" onClick={closeDropdown}>
                Download
              </Link>
            </li>
            
            {/* Language Dropdown for Desktop */}
            <li
              className="dropdown language-dropdown"
              onMouseEnter={() => setLanguageDropdownVisible(true)}
              onMouseLeave={() => setLanguageDropdownVisible(false)}
            >
              <span className="current-language">
                🌍 {selectedLanguage}
              </span>
              {/* Menu visibility controlled by isLanguageDropdownVisible state */}
              {isLanguageDropdownVisible && ( 
                <ul ref={dropdownRefLanguage} className="dropdown-menu">
                  <li><button onClick={() => handleLanguageChange("English")}>English</button></li>
                  <li><button onClick={() => handleLanguageChange("Amharic")}>አማርኛ (Amharic)</button></li>
                  <li><button onClick={() => handleLanguageChange("Tigrigna")}>ትግርኛ (Tigrigna)</button></li>
                  <li><button onClick={() => handleLanguageChange("Afan Oromo")}>Afaan Oromoo</button></li>
                </ul>
              )}
            </li>
            
            <li>
              <button onClick={handleLogout} className="logout-btn">
                Logout
              </button>
            </li>
          </>
        )}

        {/* Mobile View Links (Hamburger Menu Content) */}
        {isMobile && (
          <>
            <li><Link to="/contact" onClick={closeDropdown}>Contact</Link></li>
            <li><Link to="/download1" onClick={closeDropdown}>Download</Link></li>
            <li><button onClick={handleLogout} className="logout-btn">Logout</button></li>
            <li className="section-title">— Our Basic Services —</li>
            <li><Link to="/services/web-development" onClick={closeDropdown}>🌐 Web Development</Link></li>
            <li><Link to="/services/app-development" onClick={closeDropdown}>📱 Mobile APP Development</Link></li>
            <li><Link to="/services/dashboard" onClick={closeDropdown}>📊 Data Analysis Dashboard</Link></li>
            <li><Link to="/services/tutorial" onClick={closeDropdown}>🎓 Tutorials</Link></li>
            <li><Link to="/services/electrical" onClick={closeDropdown}>⚡ Electrical Consultancy</Link></li>
            <li className="section-title">— Latest News —</li>
            <li><Link to="/news/technology" onClick={closeDropdown}>Technology</Link></li>
            <li><Link to="/news/economics" onClick={closeDropdown}>Economics</Link></li>
            <li><Link to="/news/sport" onClick={closeDropdown}>Sport</Link></li>
            <li><Link to="/news/others" onClick={closeDropdown}>Others</Link></li>
          </>
        )}
      </ul>
    </header>
  );
};

export default Header;